<div class="dm-cart-data-servico">
  <div #datepicker class="datepicker-inline"></div>
  <div class="alert alert-info alert-message" [hidden]="!loader">
    {{messageLoader}}
  </div>  
</div>
